import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:3333";
const token = localStorage.wikiJWT;

export default {
	user: {
		login: credentials =>
			axios
				.post(`${apiUrl}/api/auth/`, { credentials })
				.then(res => res.data.user),
		signup: user =>
			axios.post(`${apiUrl}/api/users`, { user }).then(res => res.data.user),
		confirm: token =>
			axios
				.post(`${apiUrl}/api/users/confirmation`, { token })
				.then(res => res.data.user)
	},
	bookmark: {
		all: (query, offset) =>
			axios
				.get(`${apiUrl}/api/bookmarks`, {
					params: {
						offset: offset,
						...(query ? { q: query } : {})
					},
					headers: { Authorization: `Bearer ${token}` }
				})
				.then(response => response.data),
		single: uuid =>
			axios
				.get(`${apiUrl}/api/bookmarks/${uuid}`, {
					headers: { Authorization: `Bearer ${token}` }
				})
				.then(response => response.data),
		create: data =>
			axios.post(
				`${apiUrl}/api/bookmarks`,
				{ ...data },
				{ headers: { Authorization: `Bearer ${token}` } }
			),
		update: (uuid, data) =>
			axios.put(
				`${apiUrl}/api/bookmarks/${uuid}`,
				{ ...data },
				{ headers: { Authorization: `Bearer ${token}` } }
			),
		delete: uuid =>
			axios.delete(`${apiUrl}/api/bookmarks/${uuid}`, {
				headers: { Authorization: `Bearer ${token}` }
			}),
		getUrlData: url =>
			axios
				.get(`${apiUrl}/api/bookmark/getUrlData?url=${url}`)
				.then(response => response.data),
		generateScreenshot: url =>
			axios
				.get(`${apiUrl}/api/bookmark/generateScreenshot?url=${url}`)
				.then(response => response.data),
		uploadToS3: (imageUrl, id) =>
			axios.post(`${apiUrl}/api/bookmark/uploadToS3`, { imageUrl, id })
	}
};



// WEBPACK FOOTER //
// ./src/utils/api.js